





































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ITicketCreateRequest, ITicketRequest } from "@/types/ticket";
import { ITicket, ITicketUpdateRequest } from "@/types/ticket";
import { ITag, ITagCreateRequest, ITagListRequest } from "@/types/tag";
import { ISelectItem } from "@/types";
import { TicketRequest, TicketUpdateRequest } from "@/models/ticket";
import { IMemberListRequest } from "@/types/member";
import { ISalesListRequest } from "@/types/sales";
import { IStatusListRequest } from "@/types/status";

@Component({})
export default class extends Vue {
  @Action("ticket/salesGet")
  public getTicket!: (id: number) => Promise<void>;

  @Getter("ticket/single")
  public ticket!: ITicket;

  @Action("ticket/salesCreate")
  public create!: (params: ITicketCreateRequest) => Promise<boolean>;

  @Action("ticket/salesUpdate")
  public update!: (data: {
    ticket_id: number;
    params: ITicketUpdateRequest;
  }) => boolean;

  @Action("tag/saleCreate")
  public createTag!: (tagParams: ITagCreateRequest) => Promise<boolean>;

  @Action("tag/getList")
  public getTagList!: (params: ITagListRequest) => Promise<void>;

  @Getter("tag/selectItem")
  public tags!: ISelectItem[];

  @Getter("tag/single")
  public tag!: ITag;

  @Action("member/adminGetList")
  public getMemberList!: (params: IMemberListRequest) => Promise<void>;

  @Getter("member/selectItem")
  public members!: ISelectItem[];

  @Action("sales/adminGetList")
  public getSalesList!: (params: ISalesListRequest) => Promise<void>;

  @Getter("sales/selectItem")
  public saleses!: ISelectItem[];

  @Action("status/getList")
  public getStatusList!: (params: IStatusListRequest) => Promise<void>;

  @Getter("status/selectItem")
  public statuses!: ISelectItem[];

  @Mutation("ticket/clear")
  public clear!: () => void;

  public member_id = 0;
  public ticket_id = 0;
  public dialog = false;

  public params: ITicketRequest = new TicketRequest();

  public tagParams: ITagCreateRequest = {
    name: "",
  };

  private async created() {
    this.clear();

    // 編集時
    if (this.$route.params.ticket_id) {
      this.ticket_id = Number(this.$route.params.ticket_id);
      await this.getTicket(this.ticket_id);
      this.params = new TicketUpdateRequest(this.ticket);
    }

    await Promise.all([
      this.getTagList({ per_page: 0 }),
      this.getMemberList({ per_page: 0 }),
      this.getSalesList({ per_page: 0 }),
      this.getStatusList({ per_page: 0 }),
    ]);

    // memberの指定がある場合 メンバー画面下の階層の場合
    if (this.$route.params.member_id) {
      this.member_id = Number(this.$route.params.member_id);
      if (this.members.some((member) => member.value === this.member_id)) {
        this.params.members.push(this.member_id);
      }
    }

    // タグの指定がある場合 alertからの遷移時など
    if (this.params.tags.length > 0) {
      const tagId = Number(this.$route.query.tag_id);
      if (this.tags.some((tag) => tag.value === tagId)) {
        this.params.tags.push(tagId);
      }
    }
  }

  public async tagInsert(): Promise<void> {
    await this.createTag(this.tagParams);
    await this.getTagList({ per_page: 0 });
    this.params.tags.push(this.tag.id);
    this.dialog = false;
  }

  public async submit(): Promise<void> {
    let result = false;

    if (this.ticket_id) {
      result = await this.update({
        ticket_id: this.ticket.id,
        params: this.params,
      });
    } else {
      result = await this.create(this.params);
    }

    if (result) {
      this.$router.go(-1);
    }
  }
}
